/**
 * Maps the values of an object to a new value.
 * By calling the valueMapper function with each value of the object.
 */
export function mapValues<T extends object, V>(obj: T, valueMapper: (k: T[keyof T]) => V) {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, valueMapper(v)])) as {
    [K in keyof T]: V;
  };
}
